import React,{ Component } from "react";
import { connect } from "react-redux";
import { getGroups, deleteGroup ,setGroupPageInfo} from "../../actions/actionGroup";
import { Link } from "react-router-dom";
import { Row, Col, Button, Modal, ModalHeader, ModalBody, ModalFooter, UncontrolledTooltip, Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import "react-table/react-table.css";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../components/Breadcrumb/BreadCrumbCompo";
import DataTable from "../../components/Table/Table";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "Groups",path:"/groups",isActive: true},
];

class Groups extends Component{
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            groupId: null,
            groupName: null,
            force: false,
        };
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteGroupAction = this.deleteGroupAction.bind(this);
        this.cancelDelete = this.cancelDelete.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
        this.updateForce = this.updateForce.bind(this);
    }

    componentDidMount() {
        this.props.getGroups();
    }

    deleteConfirm(groupId, groupName){
        this.setState({modal: !this.state.modal,
            groupId: groupId,
            groupName: groupName});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal}); 
    }

    updateForce() {
        this.setState({force: !this.state.force});
    }

    deleteGroupAction(){
        this.props.deleteGroup(this.state.groupId, this.state.force).
            then(() => this.handleDeleteSuccess()).
            catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess(){
        const {deleteGroupErrorMessage} = this.props;
        if(deleteGroupErrorMessage) {
            NotificationManager.error(deleteGroupErrorMessage,"Delete Group Failed", 3000);
        }else{
            NotificationManager.success("Successfully Deleted Group","Delete Group", 3000);
            this.setState({modal: false});
            this.props.getGroups();
        }
    }

    handleDeleteError(){
        const {deleteGroupError} = this.props;
        if(deleteGroupError){
            NotificationManager.error(deleteGroupError,"Failed to Delete Group", 3000);
            this.props.history.push("/groups");
        }else{
            NotificationManager.error("Failed to Delete Group","Delete Group", 3000);
            this.props.history.push("/groups");
        }
    }

    render(){
        if (this.props.getGroupsLoading){
            return (<div> <LoadingSpinner /></div>);
        }

        const { groups } = this.props;

        const columns = [
            {
                type: "text",
                accessor: "name",
                name: "Name",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                accessor: "priority",
                name: "Priority",
                filterable: true,
                sortable: true
            },
            {
                type: "text",
                accessor: "description",
                name: "Description",
                filterable: true,
                sortable: true
            },
        ];

        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/viewgroup/${item.group_id}`);
                break;

                case "edit":
                    this.props.history.push(`/updategroup/${item.group_id}`);
                break;

                case "delete":
                    this.deleteConfirm(item.group_id, item.name);
                break;
            }
        }

        return (
            <div className="profile-page">
                <BreadCrumbCompo routes={routes}/>  
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                            <div className="title-head">
                                <i className="fa fa-group"></i> <strong>Groups</strong> </div>
                                <Link className="pull-right add-btn" to={{ pathname: "/creategroup" }}>
                                    <button className="pull-right adduser-btn" size="sm" color="dark">
                                    <i className="fa fa-plus" aria-hidden="true"></i> 
                                        Add Group
                                    </button>
                                </Link> 
                            </CardHeader>
                            <CardBody className="p-0">
                                <DataTable
                                    id="groups"
                                    data={groups}
                                    columns={columns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this group?
                    </ModalHeader>
                    <ModalBody className="confirm-modal-body">
                        <label id="force_label" className="group-label"><b>Force:</b> &nbsp; &nbsp;<input type="checkbox" value={this.state.force} onChange={this.updateForce}/></label>
                        <UncontrolledTooltip placement="bottom" target="force_label"> Delete the group even it currently has members. </UncontrolledTooltip>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} className="cancel-button" size="sm" color="basic"> Close</Button>
                        <Button onClick={this.deleteGroupAction} 
                        className="delete-button"
                        size="sm" color="danger">Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }
}

Groups.propTypes = {
    getGroups: Proptypes.func.isRequired,
    history: Proptypes.object.isRequired,
    deleteGroup: Proptypes.func.isRequired,
    deleteGroupErrorMessage: Proptypes.func,
    deleteGroupError: Proptypes.func,
    getGroupsLoading: Proptypes.bool,
    groups: Proptypes.array,
    className: Proptypes.func
};


export default connect(state => 
    {
    return ({
        groups: state.groups.groups || [],
        getGroupsLoading: state.groups.getGroupsLoading || false,
        deleteGroupErrorMessage: state.groups.deleteGroupErrorMessage || null,
        deleteGroupLoading: state.groups.deleteGroupLoading || false,
        deleteGroupError: state.groups.deleteGroupError || null,
    })},
    dispatch => 
    ({  
        getGroups: () => dispatch(getGroups()),
        deleteGroup: (data, force) => dispatch(deleteGroup(data, force)),
        setPageInfo : (data)=> dispatch(setGroupPageInfo(data)),
    }))(Groups);


// WEBPACK FOOTER //
// ./src/views/Groups/Groups.js